import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExtractEncryptionState } from '../../../ts/models/IDataSourceInfo';
import { CreateExtracts } from '../AppActionTypes';

export interface CreateExtractsAction extends Action {
  selectedContent: IContentInfo[];
  encryptionState: ExtractEncryptionState;
}

export function createExtractsMethod(
  selectedContent: IContentInfo[],
  encryptionState: ExtractEncryptionState
): CreateExtractsAction {
  return {
    type: CreateExtracts,
    selectedContent,
    encryptionState
  };
}
